import styled from 'styled-components'

export const Icon = styled.div`
  .rotate {
    transform: rotate(180deg);
    transition: transform 0.3s ease;
  }
`
